/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in ru. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('ru', {
	fields: {
		allowDuplicates: 'Разрешить повторяющиеся карты',
		allowReversals: 'Разрешить перевёрнутые карты',
		antardasha: 'Антардаша',
		approximateDate: 'Приблизительная дата',
		arcana: 'Аркан',
		aspectTypes: 'Типы аспектов',
		avasthaInfo: 'Включить сведения об авастхах',
		ayanamsa: 'Аянамша',
		ayanamsaValue: 'Пользовательское значение аянамши',
		biorhythm: 'Биоритм',
		birthData: 'Данные о рождении',
		birthDate: 'Дата рождения',
		birthLatitude: 'Широта места рождения',
		birthLongitude: 'Долгота места рождения',
		birthTime: 'Время рождения',
		chakra: 'Чакра',
		color: 'Цвет',
		context: 'Где вы это увидели',
		coordinateSystem: 'Система координат',
		count: 'Количество',
		currentYear: 'Год',
		date: 'Дата',
		datetime: 'Дата и время',
		day: 'День',
		division: 'Дробная карта',
		domainWeights: 'Веса сфер',
		domains: 'Сферы',
		element: 'Стихия',
		endDate: 'Дата окончания',
		endDatetime: 'Дата и время окончания',
		expression: 'Число экспрессии',
		family: 'Группа йоги',
		focus: 'Фокус',
		fullName: 'Полное имя',
		horaryNumber: 'Хорарное число',
		houseSystem: 'Система домов',
		id: 'ID',
		include: 'Дополнительные тела',
		interpretation: 'Значение положения',
		intervalMinutes: 'Интервал в минутах',
		iso2: 'Код страны',
		lang: 'Язык',
		latitude: 'Широта',
		letter: 'Начальная буква',
		lifePath: 'Число жизненного пути',
		limit: 'Результатов на странице',
		lines: 'Линии',
		longitude: 'Долгота',
		mahadasha: 'Махадаша',
		members: 'Участники группы',
		minSignificance: 'Минимальная значимость',
		minStrength: 'Минимальная сила',
		modernPlanets: 'Включить современные планеты',
		month: 'Месяц',
		name: 'Имя',
		natalChart: 'Натальная карта',
		nodeType: 'Тип лунного узла',
		number: 'Число',
		offset: 'Пропустить результатов',
		orb: 'Орбис',
		person1: 'Человек 1',
		person2: 'Человек 2',
		personA: 'Человек A',
		personB: 'Человек B',
		planet: 'Планета',
		planets: 'Планеты',
		positions: 'Позиции расклада',
		pratyantardasha: 'Пратьянтардаша',
		q: 'Поиск',
		question: 'Ваш вопрос',
		relocationLatitude: 'Широта релокации',
		relocationLongitude: 'Долгота релокации',
		returnDate: 'Дата возврата',
		returnYear: 'Год возврата',
		scheme: 'Схема карак',
		seed: 'Сид',
		sign: 'Знак зодиака',
		significators: 'Включить сигнификаторы KP',
		sookshma: 'Сукшма',
		soulUrge: 'Число душевного побуждения',
		spreadName: 'Название расклада',
		startDate: 'Дата начала',
		startDatetime: 'Дата и время начала',
		strictOrbs: 'Использовать более узкие орбисы',
		suit: 'Масть',
		system: 'Система авастх',
		targetDate: 'Целевая дата',
		targetMonth: 'Целевой месяц',
		time: 'Время',
		timezone: 'Часовой пояс',
		top: 'Топ событий за период',
		transitDate: 'Дата транзита',
		transitTime: 'Время транзита',
		type: 'Тип последовательности',
		vedic: 'Ведический',
		western: 'Западный',
		year: 'Год',
		zodiac: 'Знак зодиака',
	},
	enums: {
		'arcana.major': 'Старшие Арканы',
		'arcana.minor': 'Младшие Арканы',
		'ayanamsa.custom': 'Пользовательская',
		'ayanamsa.kp-newcomb': 'KP Newcomb',
		'ayanamsa.kp-old': 'KP Old',
		'ayanamsa.lahiri': 'Лахири',
		'ayanamsa.raman': 'Б.В. Раман',
		'chakra.Crown': 'Коронная',
		'chakra.Heart': 'Сердечная',
		'chakra.Root': 'Корневая',
		'chakra.Sacral': 'Сакральная',
		'chakra.Solar Plexus': 'Солнечное сплетение',
		'chakra.Third Eye': 'Третий глаз',
		'chakra.Throat': 'Горловая',
		'context.address': 'Адрес',
		'context.clock': 'Часы',
		'context.license-plate': 'Номерной знак',
		'context.phone': 'Номер телефона',
		'context.price': 'Цена',
		'context.receipt': 'Чек',
		'coordinateSystem.sidereal': 'Сидерический',
		'coordinateSystem.tropical': 'Тропический',
		'element.Air': 'Воздух',
		'element.Earth': 'Земля',
		'element.Fire': 'Огонь',
		'element.Storm': 'Storm',
		'element.Water': 'Вода',
		'family.akriti': 'Акрити',
		'family.asraya': 'Ашрайя',
		'family.classical': 'Классическая',
		'family.dala': 'Дала',
		'family.sankhya': 'Санкхья',
		'focus.finance': 'Финансы',
		'focus.general': 'Общее',
		'houseSystem.equal': 'Равный',
		'houseSystem.koch': 'Кох',
		'houseSystem.placidus': 'Плацидус',
		'houseSystem.whole-sign': 'Целый знак',
		'lang.de': 'Немецкий',
		'lang.en': 'Английский',
		'lang.es': 'Испанский',
		'lang.fr': 'Французский',
		'lang.hi': 'Хинди',
		'lang.pt': 'Португальский',
		'lang.ru': 'Русский',
		'lang.tr': 'Турецкий',
		'nodeType.mean': 'Средний узел',
		'nodeType.true': 'Истинный узел',
		'planet.Jupiter': 'Юпитер',
		'planet.Mars': 'Марс',
		'planet.Mercury': 'Меркурий',
		'planet.Saturn': 'Сатурн',
		'planet.Venus': 'Венера',
		'scheme.eight': 'Восемь карак',
		'scheme.seven': 'Семь карак',
		'suit.cups': 'Кубки',
		'suit.pentacles': 'Пентакли',
		'suit.swords': 'Мечи',
		'suit.wands': 'Жезлы',
		'system.baladi': 'Балади',
		'system.deeptadi': 'Диптадхи',
		'system.jagradadi': 'Jagradadi',
		'type.compound': 'Составное',
		'type.master': 'Мастер-число',
		'type.mirror': 'Зеркальное',
		'type.repeating': 'Повторяющееся',
		'type.root': 'Корневое',
		'type.sequential': 'Последовательное',
		'zodiac.aquarius': 'Водолей',
		'zodiac.aries': 'Овен',
		'zodiac.cancer': 'Рак',
		'zodiac.capricorn': 'Козерог',
		'zodiac.gemini': 'Близнецы',
		'zodiac.leo': 'Лев',
		'zodiac.libra': 'Весы',
		'zodiac.pisces': 'Рыбы',
		'zodiac.sagittarius': 'Стрелец',
		'zodiac.scorpio': 'Скорпион',
		'zodiac.taurus': 'Телец',
		'zodiac.virgo': 'Дева',
	},
});
